import { atom, getDefaultStore } from 'jotai'

import { getCurrentToken } from '@/utils/auth'

export const tokenAtom = atom<string | undefined>(getCurrentToken())

export const removeTokenAtom = () => {
  const store = getDefaultStore()
  store.set(tokenAtom, undefined)
}
